function getLocalKey(key: string): string {
	return [af?.article?.id || "", "common", key].join(".");
}

class LocalStorage {
	isPersisted = () => true;

	getLocalStorageKey(key: string, global?: boolean) {
		return global ? ["common", key].join(".") : getLocalKey(key);
	}

	get(key: string, defaultValue: unknown, global?: boolean) {
		const lsKey = this.getLocalStorageKey(key, global);
		const value = localStorage.getItem(lsKey);

		return value !== null ? JSON.parse(value) : defaultValue;
	}

	set(key: string, value: unknown, global?: boolean) {
		localStorage.setItem(this.getLocalStorageKey(key, global), JSON.stringify(value));
	}

	remove(key: string, global?: boolean) {
		const lsKey = this.getLocalStorageKey(key, global);
		if (localStorage.getItem(lsKey) !== null) {
			localStorage.removeItem(lsKey);
			return true;
		} else {
			return false;
		}
	}

	clear() {
		const baseKey = getLocalKey("");

		for (let key in localStorage) {
			if (key.slice(0, baseKey.length) === baseKey) {
				localStorage.removeItem(key);
			}
		}
	}
}

export default new LocalStorage();
